/**
 * Pure sort-value helpers for the `constants/*Options.ts` table configs.
 *
 * Deliberately dependency-free. These used to live in `textFormatters`,
 * which also holds entity formatters that read Jotai atoms and the Student
 * class — importing it from a constants module put the whole atom graph in
 * a cycle with `classOptions` / `skillLevelConstants`.
 */

/** `NaN`-safe numeric coercion for sorting mixed string/number columns. */
export const toSortableNumber = (value: unknown): number => {
  const num = Number(value)
  return Number.isNaN(num) ? 0 : num
}
